import { RemoteWallboxState } from '../../../api-data-access/models';
import { AdditionalActionCall, DownloadType, FormInputType, SettingsFormData } from '../../components';
import { FirmwareVersions, WallboxProductCodeRegex } from '../../utils';
import { WallboxConnectionType } from '../wallbox-connection-type.definition';
import { ConfigurationType, DiagnosticsKey } from '../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';

export const loggingFormDefinition: SettingsFormData[] = [
  {
    elements: [
      {
        key: DiagnosticsKey.LOG_LEVEL_DEBUG_ENABLE,
        configurationType: ConfigurationType.DIAGNOSTICS,
        type: FormInputType.TOGGLE,
        title: 'kwa.settings.logging.debug-enable.title',
        accessibilityId: 'btn--debug-enable',
        listenOnChanges: true,
        onChangeSetValues: {
          ifValue: 'true',
          setValues: [
            {
              configurationType: ConfigurationType.DIAGNOSTICS,
              configs: [{ key: DiagnosticsKey.LOG_LEVEL_DEBUG_DAYS, value: '7' }],
            },
          ],
        },
      },
      {
        key: DiagnosticsKey.LOG_LEVEL_DEBUG_DAYS,
        configurationType: ConfigurationType.DIAGNOSTICS,
        type: FormInputType.SELECT,
        title: 'kwa.settings.logging.debug-days.title',
        accessibilityId: 'btn--debug-days',
        selectOptions: [
          { key: '1', text: '1', accessibilityId: 'debug-days-1' },
          { key: '3', text: '3', accessibilityId: 'debug-days-1' },
          { key: '7', text: '7', accessibilityId: 'debug-days-1' },
        ],
        showDependentOnOtherSetting: {
          [DiagnosticsKey.LOG_LEVEL_DEBUG_ENABLE]: 'true',
        },
      },
      {
        key: AdditionalActionCall.EXPORT_DIAGNOSTICS,
        type: FormInputType.BUTTON_PRIMARY,
        disabledForWallboxStates: [RemoteWallboxState.OFFLINE, RemoteWallboxState.UNAVAILABLE],
        title: 'kwa.settings.logging.request-diagnostics.title',
        hasDownloadButton: true,
        downloadType: DownloadType.DIAGNOSTICS,
        downloadTitle: 'kwa.settings.logging.export-diagnostics.title',
        additionalActionCallType: AdditionalActionCall.EXPORT_DIAGNOSTICS,
        accessibilityId: 'btn--export-diagnosis',
        hideTitle: true,
      },
      {
        key: AdditionalActionCall.EXPORT_SECURITY_LOG,
        type: FormInputType.BUTTON_PRIMARY,
        title: 'kwa.settings.logging.request-security-log.title',
        hasDownloadButton: true,
        downloadType: DownloadType.SECURITY_LOG,
        downloadTitle: 'kwa.settings.logging.export-security-log.title',
        disabledForWallboxStates: [RemoteWallboxState.OFFLINE, RemoteWallboxState.UNAVAILABLE],
        additionalActionCallType: AdditionalActionCall.EXPORT_SECURITY_LOG,
        accessibilityId: 'btn--export-security-log',
        hideTitle: true,
        hideConditions: {
          operator: 'or',
          conditions: [
            {
              operator: 'and',
              conditions: [
                { condition: 'connectionType', value: WallboxConnectionType.REMOTE },
                { condition: 'productCode', value: WallboxProductCodeRegex.IS_P30 },
                { condition: 'firmwareVersionsBelow', value: FirmwareVersions.P30_1_19_0 },
              ],
            },
            {
              operator: 'and',
              conditions: [
                { condition: 'connectionType', value: WallboxConnectionType.REMOTE },
                { condition: 'productCode', value: WallboxProductCodeRegex.IS_P40 },
                { condition: 'firmwareVersionsBelow', value: FirmwareVersions.P40_1_1_0 },
              ],
            },
          ],
        },
      },
    ],
  },
];
